import { getSubscriptions } from "@/apis";

export const SubscriptionsDataProvider = {
  getList: async ({ resource, pagination, filters, sorters, meta }) => {
    let response;
    response = await getSubscriptions(meta.tenantName);
    if (response.status === "error") {
      throw new Error(response.error);
    } else {
      const data = response.value ? response.value[0]?.products || [] : [];
      return {
        data: data,
        total: data.length,
      };
    }
  },  
};
